import { PaginatedResponse } from '../../types';

export interface HealthInsuranceResponse extends PaginatedResponse {}

export enum HealthInsurance {
  Private = 'PRIVATE',
  Statutory = 'STATUTORY'
}
